export * from './lib/shared-util-transloco-config.module';
